var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":"הזמנות שצריך לסגור","linkTo":("/orders?orderStatuses=" + _vm.checkedInId),"actionButton":"לכל ההזמנות שצריך לסגור","number":_vm.number,"loading":_vm.loading,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }